import { render, staticRenderFns } from "./clientlistindex.vue?vue&type=template&id=f6089168"
import script from "./clientlistindex.vue?vue&type=script&lang=js"
export * from "./clientlistindex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports